import Checkbox from './Checkbox/Checkbox';
import { useJourney } from '../sitePages/Layout';

interface RenewalMarketingConsentProps {
  renewalMarketingTickboxText: string;
}

const RenewalMarketingConsent = ({
  renewalMarketingTickboxText
}: RenewalMarketingConsentProps) => {
  const { journey, onUpdateRenewalMarketing } = useJourney();

  const { renewalMarketing } = journey;

  return (
    <div>
      <Checkbox
        id='consent-to-renewal-checkbox'
        checked={renewalMarketing}
        text={renewalMarketingTickboxText}
        onChange={() => onUpdateRenewalMarketing(!renewalMarketing)}
      />
    </div>
  );
};

export default RenewalMarketingConsent;
